<template>
    <div class="automation-action-settings">

        <div class="form-group">
            <label>{{ t('automations-form-actions-smart_insertion-insertion_name_label') }}</label>
            <div>
                <small>
                    {{ t('automations-form-actions-smart_insertion-insertion_name_help') }}
                </small>
            </div>
            <input v-model="insertion.key" type="text" class="form-control">
        </div>
        <div class="form-group">
            <label>{{ t('automations-form-actions-smart_insertion-space_label') }}</label>
            <select class="form-control" v-model="insertion.spaces_id">
                <option v-for="space in spaces" :value="space.id" :key="space.id">
                    {{ space.name }}
                </option>
            </select>
        </div>
        <div class="form-group">
            <label>{{ t('automations-form-actions-smart_insertion-duration_label') }}</label>
            <input v-model="insertion.duration" type="number" class="form-control">
        </div>
        <div class="form-group field" v-for="(field, index) in fields" :key="index">
            <label v-if="field.type !== 'html' "><!-- i18n-validator-ignore-next-line: dynamic label -->{{ field.name }}</label>

            <input v-if="field.type==='text'" v-model="insertion.fields[field.name]" :type="field.type"
                   class="form-control"/>
            <textarea v-if="field.type==='textarea'" v-model="insertion.fields[field.name]" class="form-control"/>
            <div class="field" v-if="field.type ==='html'">
                <div
                    style="
                    margin-bottom: 20px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                "
                >
                    <label><!-- i18n-validator-ignore-next-line: dynamic label --> {{ field.name }} </label>
                    <button
                        class="btn btn-primary"
                        style="min-width: 150px"
                        @click.prevent="editingHTML = field.name"
                    >
                        {{ t('automations-form-actions-smart_insertion-edit_html_button') }}
                    </button>
                </div>
                <template v-if="editingHTML === field.name">
                    <grapejs
                        :tokens="tokens"
                        :html="insertion.fields[field.name] || null"
                        @saveEmail="
                        (html) => {
                            insertion.fields[field.name] = html;
                            editingHTML = '';
                        }
                    "
                        @cancelEmail="editingHTML = ''"
                    />
                </template>
                <div
                    v-show="!editingHTML"
                    class="iframe-holder"
                >
                    <iframe :ref="'iframe-'+field.name"/>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
iframe {
    border: none;
    width: 100%;
    min-height: 500px;
}

.iframe-holder {
    position: relative;
    border: 1px solid #333;
}

.wpp-cloud-components {
    display: flex;
    flex-direction: column;
    gap: 20px;

    input {
        display: inline-block;
        width: 400px;
        max-width: 80%;
    }

    .text-example {
        padding: 15px;
        border-radius: 10px;
        background: #f5f5f5;
        display: inline-block;
        width: 416px;
        max-width: 80%;
        font-size: 14px;

        strong {
            font-weight: 500;
            font-size: 16px;
        }
    }
}
</style>
<script>
import keviApi from "../../../keviApi";

export default {
    props: {
        value: {},
        properties: {},
        actionId: String,
    },
    data: function () {
        const insertion = this.properties.insertion ? this.properties.insertion : {
            duration: 7,
            spaces_id: null,
            fields: {},
            key: null,
        };
        return {
            title: this.t("automations-form-actions-smart_insertion-title"),
            spaces: [],
            insertion: insertion,
            editingHTML: null,
        }
    },
    computed: {
        space() {
            return this.spaces.find(space => space.id === this.insertion.spaces_id);
        },
        fields() {
            if (this.space) {
                return this.space.fields;
            } else {
                return [];
            }
        },
        tokens: function () {
            return this.$store.getters["automationForm/tokens"](this.actionId);
        },
    },
    async mounted() {
        await this.loadSpaces();
        this.loadPreview();
        this.$emit("mounted", this);
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        async loadSpaces() {
            const options = keviApi.getOptions("smart-insertions/spaces", "GET");
            this.$http(options).then((response) => {
                this.spaces = response.data;
            });
        },
        changed: function () {
            this.$emit("propertiesUpdated", {
                insertion: this.insertion,
            });
        },
        isValid: function () {
            return true;
        },
        loadPreview() {
            this.$nextTick(() => {
                this.fields.forEach((field) => {
                    if (field.type === "html") {
                        const iframe = this.$refs[`iframe-${field.name}`][0];
                        if (iframe) {
                            iframe.contentWindow.document.open();
                            iframe.contentWindow.document.write(this.insertion.fields[field.name]);
                            iframe.contentWindow.document.close()
                        }
                    }
                });
            })
        }
    },
    watch: {
        fields() {
            this.loadPreview();
        },
        properties: {
            handler: function (newVal) {
                this.insertion = newVal.insertion || {
                    duration: 7,
                    spaces_id: null,
                    fields: {},
                    key: null,
                };
            },
            deep: true,
        },
        'insertion.spaces_id': function () {
            this.$nextTick(() => {
                this.insertion.fields = {};
                this.fields.forEach((field) => {
                    this.$set(this.insertion.fields, field.name, '');
                });
                this.loadPreview();
            })
        },
        insertion: {
            handler: function (newVal) {
                this.loadPreview();
                this.changed();
            },
            deep: true,
        },
    },
};
</script>
